import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { ImageService } from 'src/app/services/image.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-homebanner',
    templateUrl: './homebanner.component.html',
    styleUrls: ['./homebanner.component.css']
})
export class HomebannerComponent implements OnInit {

    errorMsg: any = [];
    sno = 1;
    showPopup = false;
    loading = false;
    bannerList: any = [];
    bannerName = '';
    editBannerId = '';
    modalBoxName;
    loadingBtn = false;
    viewBox = false;
    showImage = true;
    imageUrl = '';
    defaultImage = 'assets/images/loader.gif';

    constructor(
        private apiService: ApiService,
        private toastr: ToastrService,
        private imageService: ImageService
    ) { }

    ngOnInit() {
        this.index();
        this.imageUrl = this.imageService.getImageUrl();
    }

    index() {
        this.loading = true;
        this.apiService.index('getAllHomeBanner').subscribe(data => {
            this.bannerList = data.data;
            this.loading = false;
        });
    }

    store() {
        this.loadingBtn = true;
        this.apiCall('store', 'HomeBanner');
    }

    show(id) {
        this.apiService.show('HomeBanner/' + id).subscribe((data) => {
            const value = data.data;
            this.bannerName = value.banner_name;
            this.editBannerId = id;
        });
    }

    update(id) {
        this.loadingBtn = true;
        this.apiCall('update', 'HomeBanner/' + id);
    }

    destroy(id) {
        this.swalCall(id);
    }

    bannerSwitch(id) {
        this.apiCall('getData', 'HomeBannerSwitch/' + id);
    }

    apiCall(name, url, value: any = '') {
        value = name === 'store' || name === 'update' ? {
            banner_name: this.bannerName,
        } : value;
        this.apiService[name](url, value).subscribe((data) => {
            if (data.error === false) {
                this.toastr.success(data.message);
                this.loadingBtn = false;
                this.popUpClose();
                this.index();
            } else {
                this.toastr.error(data.message);
                this.loadingBtn = false;
                this.errorMsg = data.data;
            }
        });
    }

    openModalBox(id = '') {
        if (id) {
            this.modalBoxName = 'Edit';
            this.show(id);
        } else {
            this.modalBoxName = 'Create';
        }
        this.showPopup = true;
    }

    popUpClose() {
        this.showPopup = false;
        this.bannerName  = this.editBannerId = '';
        this.errorMsg = [];
        this.viewBox = false;
    }

    swalCall(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this data!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                this.apiCall('destroy', 'HomeBanner/' + id);
                Swal.fire(
                    'Deleted!',
                    'Your data has been deleted.',
                    'success'
                );
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                    'Cancelled',
                    'Your data is safe.',
                    'error'
                );
            }
        });
    }
}
